import { createFileRoute, Outlet, redirect, useMatches, useNavigate, useParams } from '@tanstack/react-router'
import { WargaShell } from '../../../../components/WargaShell'
import { useWargaLogout, useWargaMe } from '../../../../hooks/useApi'

export const Route = createFileRoute('/desa/$slug/warga')({
  beforeLoad: async ({ location, params }) => {
    // Login page tidak perlu auth
    if (location.pathname.endsWith('/login')) return {}

    try {
      const res = await fetch('/api/warga-portal/me', { credentials: 'include' })
      if (!res.ok) throw new Error('not authenticated')
      const warga = await res.json()
      return { warga }
    } catch {
      throw redirect({ to: `/desa/${params.slug}/warga/login`, search: { redirect: location.pathname } } as any)
    }
  },
  component: WargaLayout,
})

function WargaLayout() {
  const navigate = useNavigate()
  const params = useParams({ strict: false }) as { slug?: string }
  const slug = params.slug ?? ''

  const matches = useMatches()
  const lastMatch = matches[matches.length - 1]
  const isLoginPage = lastMatch?.pathname?.endsWith('/login') ?? false
  const pathAfterWarga = lastMatch?.pathname?.split(`/desa/${slug}/warga/`)[1] ?? ''
  const activeTab = pathAfterWarga || 'beranda'

  const { data: warga } = useWargaMe(!isLoginPage)
  const logout = useWargaLogout()

  // Jangan render shell di halaman login
  if (isLoginPage) {
    return <Outlet />
  }

  const handleTabChange = (tab: string) => {
    const path = tab === 'beranda' ? `/desa/${slug}/warga` : `/desa/${slug}/warga/${tab}`
    navigate({ to: path as any })
  }

  const handleLogout = () => {
    logout.mutate(undefined, {
      onSuccess: () => navigate({ to: `/desa/${slug}/warga/login` as any }),
    })
  }

  return (
    <WargaShell
      desaName={warga?.desa?.nama ?? 'Desa'}
      aiName={warga?.desa?.nama_ai ?? 'Jenna'}
      userName={warga?.nama ?? 'Warga'}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      onLogout={handleLogout}
    >
      <Outlet />
    </WargaShell>
  )
}
